import React, { useRef, useEffect } from "react";
import { useControls, folder } from "leva";
import useCustomizerStore from "../../../../state/customizer";
import useTransitionStore from "../../../../state/transitions";
import useFogControlStore from "../../../../state/fogControls";

export default React.memo(function Lights() {
  const DisplayMode = useTransitionStore((s) => s.DisplayMode);
  const DayMode = useTransitionStore((s) => s.DayMode);
  const SuspensionMode = useTransitionStore((s) => s.SuspensionMode);
  const model = useCustomizerStore((s) => s.model);
  const selectedInterior = useCustomizerStore(
    (s) => s.selectionByModel[s.model]?.interior
  );
  const ambientLightSettings = useFogControlStore((state) => state.ambientLight);
  const ambientLight = useRef();

  useEffect(() => {
    let baseIntensity = 0;

    if (DisplayMode === "interior") {
      if (model < 2) baseIntensity = 0.15;
      else if (selectedInterior === 0) baseIntensity = 0.45;
      else if (selectedInterior === 1) baseIntensity = 0.05;
      else if (selectedInterior === 2) baseIntensity = 0.04;
    } else {
      if (SuspensionMode) {
        baseIntensity = 0.36;
      } else if (DayMode === "day" && DisplayMode !== "flipper") {
        baseIntensity = 0;
      } else if (DisplayMode == "flipper") {
        baseIntensity = 0.2;
      } else if (DayMode == "night") baseIntensity = 0.36;
      else baseIntensity = 0.5;
    }
    ambientLight.current.intensity = ambientLightSettings.enabled
      ? baseIntensity * ambientLightSettings.intensityMultiplier
      : 0;
    ambientLight.current.color.set(ambientLightSettings.color);
  }, [
    DisplayMode,
    selectedInterior,
    model,
    DayMode,
    SuspensionMode,
    ambientLightSettings.enabled,
    ambientLightSettings.intensityMultiplier,
    ambientLightSettings.color,
  ]);

  const { intensity, color } = useControls({
    ambientLight: folder({
      intensity: { value: 0, min: 0, max: 3, step: 0.001 }, //.12
      color: {
        value: "#ffffff",
        onChange: (val) => {
          ambientLight.current.color.set(val);
        },
      },
    }),
  });
  return (
    <>
      <pointLight
        intensity={model < 2 ? 0.08 : selectedInterior == 2 ? 0.2 : 0.3}
        visible={DisplayMode == "interior"}
      />
      <ambientLight
        ref={ambientLight}
        color={ambientLightSettings.color || color}
        intensity={0}
      />
    </>
  );
});
